import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { InputMaskModule } from 'primeng/inputmask';
import { InputTextModule } from 'primeng/inputtext';
import { AddressEditModalComponent } from './address-edit-modal.component';

@NgModule({
  declarations: [AddressEditModalComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ButtonModule,
    DropdownModule,
    InputMaskModule,
    InputTextModule
  ],
  exports: [AddressEditModalComponent]
})
export class AddressEditModalModule {}
